module.exports = __webpack_public_path__ + "img/img015.8239f027.png";